import React from "react";
import PropTypes from "prop-types";
import ControlBarButton from "core/ControlBarButton";
import { addSentryUserAction } from "../utils";

const sentryUserAction = { mainComponent: "TranslateButton" };

const TranslateButton = ({ onClick, isDisabled }) => (
  <ControlBarButton
    name="translate"
    onClick={() => {
      onClick();
      addSentryUserAction({
        ...sentryUserAction,
        clickedComponent: "ControlBarButton",
        action: `Translate Unit Item`,
      });
    }}
    isDisabled={isDisabled}
    isLoading={false}
    isActive={false}
  />
);

TranslateButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
};

export default TranslateButton;
